import { bootstrapApplication } from '@angular/platform-browser';
import '@odilo/ui-components';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';
import { captureInitialSearchParams } from './app/core/initial-search-params';
import { initializeDocumentTheme } from './app/helpers/reader-themes';

captureInitialSearchParams(window.location.search);

initializeDocumentTheme();

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
});
